import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useMutation } from "@apollo/client";
import swal from "sweetalert";
import Header from "../../../../components/Header";
import {
  CREATE_SMS_TEMPLATE,
  UPDATE_SMS_TEMPLATE,
} from "../../../../data/SetupManagementData";
import useMediaQuery from "@mui/material/useMediaQuery";

const SMSTemplateForm = (props) => {
  const [createSMSTemplate] = useMutation(CREATE_SMS_TEMPLATE, {
    onCompleted: () => {
      props.onClose();
      props.onAction();
      swal("Success!", "SMS Template has been created successfully", "success");
    },
    onError: (error) => {
      swal("Error!", "Unable to create SMS template, try again later", "error");
    },
  });

  const [updateSMSTemplate] = useMutation(UPDATE_SMS_TEMPLATE, {
    onCompleted: () => {
      props.onClose();
      props.onAction();
      swal("Success!", "SMS Template has been updated successfully", "success");
    },
    onError: (error) => {
      swal("Error!", "Unable to update SMS template, try again later", "error");
    },
  });

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const initialValues = {
    messageTemplate: props.data ? props.data.messageTemplate : "",
  };

  const validationSchema = yup.object().shape({
    messageTemplate: yup.string().required("Message Template is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const { messageTemplate } = values;
    console.log("Submitting values:", values);

    try {
      if (props.isEditing) {
        await updateSMSTemplate({
          variables: {
            id: props.data.id,
            messageTemplate,
          },
        });
        console.log("SMS Template updated successfully!");
      } else {
        await createSMSTemplate({
          variables: {
            messageTemplate,
          },
        });
        console.log("SMS Template created successfully!");
      }
    } catch (error) {
      console.error("Error:", error.message);
    }

    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit SMS Template" : "Create SMS Template"}
        subtitle={
          props.isEditing
            ? "Edit an Existing SMS Template"
            : "Create a New SMS Template"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Message Template *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.messageTemplate}
                name="messageTemplate"
                error={touched.messageTemplate && !!errors.messageTemplate}
                helperText={touched.messageTemplate && errors.messageTemplate}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default SMSTemplateForm;
